/* PestRx Lander Quiz — extracted scripts
 * Auto-generated 2026-05-08 from sections/pestrx-lander-quiz.liquid
 * Do not edit directly; edit the source then re-run the extraction script.
 */

/* ─────────────────────────────────────────────────────────────
     Variant map - device count (1–15) → Shopify variant info
     Hardcoded in index.html local preview. In production Liquid,
     this is rendered server-side from product.variants.
     ───────────────────────────────────────────────────────────── */
  // PestRx product GID: gid://shopify/Product/8307471417391 (handle: pestrx-keeps-pests-away-ultrasonic-repeller). Switched 2026-06-12 from the AntRx product to the dedicated PestRx product.
  // Variant IDs + prices fetched from Shopify Admin API 2026-05-07. SKUs unchanged.
  // Variant titles in Shopify still read "RodentRx" (cosmetic Shopify-side data quirk; doesn't affect cart behavior).
  window.VARIANT_MAP_BY_COUNT = {
    "1":  { id: 45484015910959, sku: "HPRX-ULTRA-V01-01PK", price: "$44.95",  label: "1-Pack" },
    "2":  { id: 45484016042031, sku: "HPRX-ULTRA-V01-02PK", price: "$79.90",  label: "2-Pack" },
    "3":  { id: 45484015976495, sku: "HPRX-ULTRA-V01-03PK", price: "$104.85", label: "3-Pack" },
    "4":  { id: 45484016074799, sku: "HPRX-ULTRA-V01-04PK", price: "$115.80", label: "4-Pack" },
    "5":  { id: 45484015943727, sku: "HPRX-ULTRA-V01-05PK", price: "$119.75", label: "5-Pack" },
    "6":  { id: 45484016107567, sku: "HPRX-ULTRA-V01-06PK", price: "$137.70", label: "6-Pack" },
    "7":  { id: 45484016140335, sku: "HPRX-ULTRA-V01-07PK", price: "$153.65", label: "7-Pack" },
    "8":  { id: 45484016173103, sku: "HPRX-ULTRA-V01-08PK", price: "$167.60", label: "8-Pack" },
    "9":  { id: 45484016205871, sku: "HPRX-ULTRA-V01-09PK", price: "$179.55", label: "9-Pack" },
    "10": { id: 45484016009263, sku: "HPRX-ULTRA-V01-10PK", price: "$195.00", label: "10-Pack" },
    "11": { id: 45484016238639, sku: "HPRX-ULTRA-V01-11PK", price: "$214.50", label: "11-Pack" },
    "12": { id: 45484016271407, sku: "HPRX-ULTRA-V01-12PK", price: "$234.00", label: "12-Pack" },
    "13": { id: 45484016304175, sku: "HPRX-ULTRA-V01-13PK", price: "$253.50", label: "13-Pack" },
    "14": { id: 45484016336943, sku: "HPRX-ULTRA-V01-14PK", price: "$273.00", label: "14-Pack" },
    "15": { id: 45484016369711, sku: "HPRX-ULTRA-V01-15PK", price: "$292.50", label: "15-Pack" }
  };

/* ─── extracted block boundary ─── */

// Topbar slider on mobile only - fades one message at a time.
  // Desktop (>=720px) shows all messages inline via CSS; slider is a no-op.
  (function() {
    var MOBILE_MAX = 1000;
    var msgs = document.querySelectorAll('.topbar-msg');
    if (msgs.length < 2) return;

    var idx = 0;
    var timer = null;

    function show(i) {
      msgs.forEach(function(m, j) {
        m.classList.toggle('is-active', j === i);
      });
    }

    function start() {
      if (timer) return;
      show(0);
      idx = 0;
      timer = setInterval(function() {
        idx = (idx + 1) % msgs.length;
        show(idx);
      }, 5000);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      // desktop: CSS handles display of all messages; ensure no JS state fights it
      msgs.forEach(function(m) { m.classList.remove('is-active'); });
    }

    function sync() {
      if (window.innerWidth < MOBILE_MAX) start();
      else stop();
    }

    sync();
    window.addEventListener('resize', sync);
  })();

  function toggleFaq(item) {
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(f) { f.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  }

  // See-more reviews — mobile reveals 3 at a time, desktop reveals 5 at a time.
  // Mobile starts with 3 visible (cards 1-3); cards 4-6 carry .ugc-card-mobile-hidden.
  // Desktop starts with 6 visible (cards 1-6); cards 7+ carry .ugc-card-hidden.
  // Reveal priority on mobile: drain mobile-hidden first, then fall through to globally hidden.
  function showMoreReviews() {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
    var batchSize = isMobile ? 3 : 5;
    var revealed = 0;

    if (isMobile) {
      var mobileHidden = document.querySelectorAll('.ugc-card.ugc-card-mobile-hidden');
      for (var i = 0; i < mobileHidden.length && revealed < batchSize; i++) {
        mobileHidden[i].classList.remove('ugc-card-mobile-hidden');
        revealed++;
      }
    }
    if (revealed < batchSize) {
      var hidden = document.querySelectorAll('.ugc-card.ugc-card-hidden');
      for (var j = 0; j < hidden.length && revealed < batchSize; j++) {
        hidden[j].classList.remove('ugc-card-hidden');
        revealed++;
      }
    }
    updateSeeMoreCount();
    if (typeof gtag === 'function') {
      try { gtag('event', 'reviews_expanded', { batch_revealed: revealed, viewport: isMobile ? 'mobile' : 'desktop' }); } catch(e) {}
    }
  }
  function updateSeeMoreCount() {
    var wrap = document.getElementById('ugc-see-more-wrap');
    if (!wrap) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
    var hidden = document.querySelectorAll('.ugc-card.ugc-card-hidden').length;
    if (isMobile) {
      hidden += document.querySelectorAll('.ugc-card.ugc-card-mobile-hidden').length;
    }
    if (hidden === 0) { wrap.style.display = 'none'; }
    else { wrap.style.display = ''; }
  }
  // Recompute the see-more button visibility on viewport flip (rotate / dev tools resize)
  if (window.matchMedia) {
    var mql = window.matchMedia('(max-width: 639px)');
    if (mql.addEventListener) { mql.addEventListener('change', updateSeeMoreCount); }
    else if (mql.addListener) { mql.addListener(updateSeeMoreCount); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSeeMoreCount);
  } else {
    updateSeeMoreCount();
  }

  function toggleCalc(btn) {
    var panel = document.getElementById('calc-panel');
    var open = panel.classList.toggle('open');
    btn.textContent = open ? 'Hide coverage guide ↑' : 'Not sure how many units you need? →';
  }

  var calcVariantIndex = [0, 1, 2, 3]; // maps calc option to variant button index
  function calcResult(opt, variantIdx, html) {
    document.querySelectorAll('.calc-opt').forEach(o => o.style.background = '');
    opt.style.background = 'var(--gold-pale)';
    var result = document.getElementById('calc-result');
    result.innerHTML = '✓ ' + html;
    result.classList.add('show');
    // highlight the recommended variant
    var variants = document.querySelectorAll('.variant-btn');
    if (variants[variantIdx]) variants[variantIdx].click();
  }

  function switchImg(thumb, src) {
    document.querySelectorAll('.hero-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    document.getElementById('main-img').src = src;
  }

  var perDayMap = {'$44.95':'$0.12','$104.85':'$0.29','$119.75':'$0.33','$195.00':'$0.53'};

  function selectVariant(btn, price, was, save, perUnit) {
    document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    // update price display
    document.getElementById('price-main').textContent = price;
    document.getElementById('price-was').textContent = was;
    document.getElementById('price-save').textContent = 'Save ' + save;
    document.getElementById('price-per').textContent = perUnit + (perUnit.includes('23.95') ? ', best value' : '');
    // update per-day cost
    var pd = perDayMap[price] || '';
    var pdEl = document.getElementById('price-per-day');
    if (pdEl) pdEl.innerHTML = pd ? 'That\'s <strong>' + pd + '/day</strong> for room-by-room coverage, instead of a product for each pest' : '';
    // update sticky with per-day
    var name = btn.querySelector('.variant-name').textContent;
    document.getElementById('sticky-price').innerHTML = (pd ? pd + '/day' : price) + '<small>' + name + (pd ? ' · ' + price + ' total' : '') + ' · Save ' + save + '</small>';
    // update + show variant confirmation chip
    var confirm = document.getElementById('variant-confirm');
    document.getElementById('variant-confirm-text').textContent = name + ' selected: ' + price;
    confirm.classList.add('show');
  }

  // Add selected variant to cart and redirect straight to checkout.
  // Uses Shopify's /cart/ URL format which adds + redirects in one step.
  // Works cross-origin (from landing pages hosted off-Shopify) and same-origin.
  function addToCartAndGo(overrideVariantId) {
    var variantId = overrideVariantId;

    if (!variantId) {
      var selected = document.querySelector('.variant-btn.selected');
      if (!selected) { selected = document.querySelector('.variant-btn.popular') || document.querySelector('.variant-btn'); }
      var pack = selected.getAttribute('data-pack') || '5';
      var map = window.VARIANT_MAP_BY_COUNT || {};
      var variant = map[pack];
      variantId = variant ? variant.id : null;
    }

    if (!variantId) { window.location.href = 'https://hellopest.org/checkout'; return; }

    // Disable all CTA buttons while redirect happens
    var btns = document.querySelectorAll('.btn-buy, .nav-cta, .vt-cta, .btn-dark, .sticky-cta-btn');
    btns.forEach(function(b) { b.style.pointerEvents = 'none'; b.style.opacity = '0.7'; });

    // Shopify direct-to-checkout URL: clears cart, adds variant, goes to checkout.
    // Note: previously appended ?checkout=1 — Shopify now rejects that with "expected String
    // to be a Hash: checkout" (broken 2026-05-08). Plain /cart/{variantId}:1 works correctly
    // and lands on a clean checkout page directly.
    window.location.href = 'https://hellopest.org/cart/' + variantId + ':1';
  }

  // "Stop the Ants" buttons (nav, sticky, footer):
  // - cart has items → go to /checkout
  // - otherwise → smooth-scroll to the quiz section
  window.__hasCartItems = false;
  (function() {
    if (location.protocol === 'file:') return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(cart) {
        if (cart && typeof cart.item_count === 'number') {
          window.__hasCartItems = cart.item_count > 0;
        }
      })
      .catch(function() {});
  })();
  function protectMyHomeClick(e) {
    e.preventDefault();
    if (window.__hasCartItems) {
      window.location.href = '/checkout';
      return;
    }
    var quiz = document.getElementById('quiz');
    if (quiz) quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Sticky CTA: show after hero CTA leaves viewport, but hide while the
  // quiz section is on screen so the developing plan isn't obscured.
  (function() {
    var heroCta = document.querySelector('.hero-cta-stack');
    var quiz = document.getElementById('quiz');
    var stickyCta = document.querySelector('.sticky-cta');
    if (!heroCta || !stickyCta) return;
    function update() {
      if (window.innerWidth >= 900) { stickyCta.classList.remove('visible'); return; }
      var heroRect = heroCta.getBoundingClientRect();
      var pastHero = heroRect.bottom <= 0;
      var quizInView = false;
      if (quiz) {
        var qr = quiz.getBoundingClientRect();
        quizInView = qr.top < window.innerHeight && qr.bottom > 0;
      }
      if (pastHero && !quizInView) stickyCta.classList.add('visible');
      else stickyCta.classList.remove('visible');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();

  // Daily-drifting social-proof counts. Each day past the baseline, a small
  // deterministic number of new customers is added; a fraction of those
  // "leave reviews." Deterministic per calendar day so all occurrences on
  // the page show the same value and the count doesn't jitter within a visit.
  (function() {
    var BASELINE = { date: '2026-04-17', households: 11247, reviews: 2847 };
    var parts = BASELINE.date.split('-');
    var base = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    var today = new Date();
    base.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    var days = 0; // frozen to true baseline (no manufactured daily drift)
    function rnd(n) {
      var t = (n + 0x6D2B79F5) | 0;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }
    var households = BASELINE.households;
    var reviews = BASELINE.reviews;
    for (var i = 1; i <= days; i++) {
      var newCustomers = 8 + Math.floor(rnd(i) * 11);
      var reviewFrac = 0.25 + rnd(i + 100000) * 0.10;
      households += newCustomers;
      reviews += Math.round(newCustomers * reviewFrac);
    }
    var hhNew = households.toLocaleString('en-US');
    var rvNew = reviews.toLocaleString('en-US');
    var hhOld = BASELINE.households.toLocaleString('en-US');
    var rvOld = BASELINE.reviews.toLocaleString('en-US');
    if (hhOld === hhNew && rvOld === rvNew) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (v.indexOf(hhOld) === -1 && v.indexOf(rvOld) === -1) continue;
      node.nodeValue = v.split(hhOld).join(hhNew).split(rvOld).join(rvNew);
    }
  })();

/* ─── extracted block boundary ─── */

(function() {
  /* Q1 reflex icons (quiz-builder skill, best-practices 2a): simple line icons,
     stroke inherits the button text color via currentColor. aria-hidden; the
     option text remains the accessible label. */
  var PEST_ICONS = {
    RODENT: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="14" cy="19.5" rx="10" ry="7"/><circle cx="10" cy="11.5" r="3"/><circle cx="7" cy="18" r="0.5" fill="currentColor"/><path d="M24 19.5c3.5-0.5 5.5 1.5 4.5 4"/></svg>',
    ROACH: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="16" cy="19" rx="6" ry="8.5"/><path d="M16 13v13"/><path d="M13.5 9.5C13.5 7.5 14.5 6 16 6s2.5 1.5 2.5 3.5"/><path d="M14 7C12 4.5 9.5 3.5 7 3.5"/><path d="M18 7c2-2.5 4.5-3.5 7-3.5"/><path d="M10.5 14.5 5 12"/><path d="M10 19H4"/><path d="M10.5 23.5 5 27"/><path d="M21.5 14.5 27 12"/><path d="M22 19h6"/><path d="M21.5 23.5 27 27"/></svg>',
    SPIDER: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="19" r="5"/><circle cx="16" cy="11.5" r="2.7"/><path d="M12.2 16.5C8.5 14 6.5 11 5.5 7.5"/><path d="M11.2 18.5C6.5 17.5 4 15.5 2.5 13"/><path d="M11.3 20.8C7.5 22 5.5 24 4.5 27"/><path d="M13.2 23.3c-2.7 2.4-3.7 4.2-4 6.2"/><path d="M19.8 16.5c3.7-2.5 5.7-5.5 6.7-9"/><path d="M20.8 18.5c4.7-1 7.2-3 8.7-5.5"/><path d="M20.7 20.8c3.8 1.2 5.8 3.2 6.8 6.2"/><path d="M18.8 23.3c2.7 2.4 3.7 4.2 4 6.2"/></svg>',
    ANT: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="7.5" r="3"/><ellipse cx="16" cy="14.5" rx="2.6" ry="3"/><ellipse cx="16" cy="23.5" rx="3.6" ry="5"/><path d="M14.2 5.2C12.5 3.5 10.5 2.8 8.5 2.8"/><path d="M17.8 5.2c1.7-1.7 3.7-2.4 5.7-2.4"/><path d="M13.5 13 8 10.5"/><path d="M13.4 15.5 7.5 16"/><path d="M14 17.5 9 21"/><path d="M18.5 13l5.5-2.5"/><path d="M18.6 15.5l5.9 0.5"/><path d="M18 17.5l5 3.5"/></svg>',
    MIX: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="16" r="11.5"/><path d="M12.7 13.2c0-2.1 1.5-3.7 3.4-3.7 1.9 0 3.3 1.4 3.3 3.2 0 2.9-3.4 2.9-3.4 5.6"/><circle cx="16" cy="22.6" r="0.6" fill="currentColor"/></svg>'
  };

  var QUESTIONS = {
    Q_PEST: {
      text: 'Which pests are you dealing with inside? Select all that apply.',
      options: [
        { id: 'RODENT', text: 'Mice or rats', icon: PEST_ICONS.RODENT },
        { id: 'ROACH', text: 'Cockroaches', icon: PEST_ICONS.ROACH },
        { id: 'SPIDER', text: 'Spiders', icon: PEST_ICONS.SPIDER },
        { id: 'ANT', text: 'Ants', icon: PEST_ICONS.ANT },
        { id: 'MIX', text: 'Not sure which, or other pests too', icon: PEST_ICONS.MIX }
      ], multi: true
    },
    Q1: {
      text: "Where are you with these pests right now?",
      options: [
        { id: 'A', text: 'I\u2019m seeing them now' },
        { id: 'B', text: 'Had a problem before, I want to prevent a repeat' },
        { id: 'C', text: 'Nothing yet, but I\u2019m concerned' },
        { id: 'D', text: 'I\u2019ve tried things and it keeps coming back' }
      ], multi: false
    },
    Q2: {
      text: 'What type of home do you live in?',
      options: [
        { id: 'A', text: 'Single-family house (no shared walls)' },
        { id: 'B', text: 'Townhouse or duplex (at least one shared wall)' },
        { id: 'C', text: 'Apartment or condo (multi-unit building)' },
        { id: 'D', text: 'Mobile or manufactured home' }
      ], multi: false
    },
    Q3: {
      text: 'Do you have a garage?',
      options: [
        { id: 'A', text: 'No garage' },
        { id: 'B', text: 'Yes, attached (1 or 2 car)' },
        { id: 'C', text: 'Yes, attached (3 car or larger)' },
        { id: 'D', text: 'Yes, detached' }
      ], multi: false
    },
    Q_BSMT: {
      text: 'Does your home have a basement or crawlspace?',
      options: [
        { id: 'A', text: 'Finished basement (a usable room)' },
        { id: 'B', text: 'Unfinished basement' },
        { id: 'C', text: 'Crawlspace or dirt-floor space' },
        { id: 'D', text: 'No basement or crawlspace' }
      ], multi: false
    },
    Q3_APT: {
      text: 'Which best describes your unit?',
      options: [
        { id: 'A', text: 'Ground floor, separate rooms' },
        { id: 'B', text: 'Ground floor, studio or open plan' },
        { id: 'C', text: 'Upper floor, separate rooms' },
        { id: 'D', text: 'Upper floor, studio or open plan' }
      ], multi: false
    },
    Q_BSMT_APT: {
      text: 'Is there a basement or crawlspace directly below your unit?',
      options: [
        { id: 'A', text: 'Yes, and it\u2019s my space or I can access it' },
        { id: 'B', text: 'Yes, but it\u2019s the building\u2019s, not mine' },
        { id: 'C', text: 'No, I\u2019m on a slab' }
      ], multi: false
    },
    Q3_MOB: {
      text: 'Does your home have a storage shed or detached structure attached by a walkway?',
      options: [
        { id: 'A', text: 'Yes' },
        { id: 'B', text: 'No' }
      ], multi: false
    },
    Q5_MOB: {
      text: 'How would you describe the layout of your home?',
      options: [
        { id: 'A', text: 'Open plan (kitchen, living, and dining all connected)' },
        { id: 'B', text: 'Separated rooms with hallways' }
      ], multi: false
    },
    Q_ROOMS: {
      text: function(s) {
        var base = 'Which rooms have you actually seen them in? Pick each one that applies.';
        if (s.home === 'MOBILE') return base + ' Your kitchen and entry are already covered.';
        var covered = [];
        if (s.answers.Q3 === 'B' || s.answers.Q3 === 'C' || s.answers.Q3 === 'D') covered.push('garage');
        if (s.answers.Q_BSMT && s.answers.Q_BSMT !== 'D') covered.push('basement');
        if (covered.length === 2) return base + ' Your garage and basement are already covered, so skip those.';
        if (covered.length === 1) return base + ' Your ' + covered[0] + ' is already covered, so skip it.';
        return base;
      },
      options: [
        { id: 'KITCHEN', text: 'Kitchen' },
        { id: 'BATH', text: 'Bathroom or under-sink' },
        { id: 'UTILITY', text: 'Utility or laundry room' },
        { id: 'BEDROOM', text: 'A bedroom' },
        { id: 'QUIET', text: 'A quiet or storage room' },
        { id: 'ATTIC', text: 'Attic' },
        { id: 'LIVING', text: 'Living or dining room' },
        { id: 'NONE', text: 'None of these / I have not pinpointed a room' }
      ], multi: true, allowZero: true,
      filterOptions: function(st) {
        var elig = st.eligibleRooms || [];
        return function(opt) {
          if (opt.id === 'NONE') return true;
          return elig.indexOf(opt.id) !== -1;
        };
      }
    },
    Q_ROOMS_APT: {
      text: 'Which rooms have you actually seen them in? Pick each one that applies.',
      options: [
        { id: 'KITCHEN', text: 'Kitchen' },
        { id: 'BATH', text: 'Bathroom or under-sink' },
        { id: 'BEDROOM', text: 'A bedroom' },
        { id: 'LIVING', text: 'Living or dining room' },
        { id: 'QUIET', text: 'A closet or storage area' },
        { id: 'NONE', text: 'None of these / I have not pinpointed a room' }
      ], multi: true, allowZero: true,
      filterOptions: function(st) {
        var elig = st.eligibleRooms || [];
        var studio = st.answers.Q3_APT === 'B' || st.answers.Q3_APT === 'D';
        return function(opt) {
          if (opt.id === 'NONE') return true;
          if (studio && opt.id !== 'BATH' && opt.id !== 'QUIET') return false;
          return elig.indexOf(opt.id) !== -1;
        };
      }
    }
  };

  var TEMPLATES = {
    ACTIVE_KITCHEN: {
      headline: 'Active pests in one main room? Here\u2019s how to cover it.',
      body: 'Your [N]-device plan creates two lines of defense: one at the entry points where they\u2019re getting in, and one in the room where you\u2019re seeing them. Place that device on the wall closest to the activity, low and near the baseboard. The ultrasonic field makes the space read as unsafe, so they stop settling there.',
      flag: ''
    },
    ACTIVE_MULTI: {
      headline: 'Activity in multiple rooms means they\u2019re established. Your plan matches that scale.',
      body: 'Your [N]-device plan covers every room where you\u2019ve seen activity plus the entry pathways feeding it. Start with the basement, garage, and door placements first to cut off new arrivals, then cover the interior rooms.',
      flag: ''
    },
    ACTIVE_UNLOCATED: {
      headline: 'You know they\u2019re there. Let\u2019s cover every likely route until you spot them.',
      body: 'Your [N]-device plan covers all primary entry and activity zones. Start by checking the high-yield spots: behind the refrigerator, under the kitchen sink, along baseboards, in the garage or basement, and around any pet water bowl. Garage and exterior doors are always the first placements.',
      flag: ''
    },
    PREV_HIST: {
      headline: 'You know what this looks like. Here\u2019s how to keep it from coming back.',
      body: 'Your [N]-device plan is built around the entry vectors most likely to let pests back in. Garage and exterior doors are your first line of defense. Where you found activity last time is the same place they\u2019ll try again, so prioritize that zone.',
      flag: ''
    },
    PREV_NEW: {
      headline: 'Prevention is easier than fighting an active problem. Here\u2019s your starting point.',
      body: 'Your [N]-device plan focuses on the entry pathways that account for most intrusions: the basement and garage if you have them, plus your exterior door thresholds. You don\u2019t need full interior coverage yet. Entry-first deterrence is the right first investment, so your home feels unwelcoming before pests ever settle in.',
      flag: ''
    },
    CHRONIC: {
      headline: 'If what you\u2019ve tried before isn\u2019t working, the issue is usually placement, not the product.',
      body: 'Most ultrasonic devices fail because they\u2019re placed in interior rooms pests are already in, not at the pathways where they get in. Your [N]-device plan is built entry-first: basement, garage, and door placements come first, then any room you can pinpoint. The goal is to make your home read as unwelcoming at the way in, not just where you see them.',
      flag: ''
    },
    APT_GROUND: {
      headline: 'Ground-floor units take the most entry pressure. Here\u2019s where your devices go.',
      body: 'Your [N]-device plan starts at your unit\u2019s entry door. The gap under the threshold is the most common way in, especially in older buildings with worn weather-stripping. Your placement list below names every spot, so nothing is guesswork.',
      flag: ''
    },
    APT_UPPER: {
      headline: 'Upper floors get less entry pressure. A small, focused plan covers yours.',
      body: 'Your [N]-device plan starts at your unit\u2019s entry door. Shared walls are the other route: pests travel plumbing risers and cable runs from floors below, so seal any visible pipe or cable penetrations with caulk or foam and let the device cover the room side.',
      flag: ''
    },
    MOBILE: {
      headline: 'Floor and pier-foundation gaps are the biggest entry risk. Here\u2019s how to cover them.',
      body: 'Mobile and manufactured homes have unique entry vulnerabilities at the pier-foundation perimeter. Every utility penetration through the floor is a potential route. Device 1: entry-door zone. Device 2: kitchen. Device 3 (if separated rooms): hallway midpoint to create a continuous signal corridor between zones.',
      flag: 'Pier-foundation gaps are an exclusion priority. A skirting seal or hardware cloth around the base perimeter is the highest-leverage parallel action you can take. PestRx covers above the floor; sealing covers below.'
    }
  };

  /* Quiz recommends 1–15 devices. Map directly to the matching variant via window.VARIANT_MAP_BY_COUNT. */
  var MAX_VARIANT_PACK = 15;

  /* ── ROOM MODEL (2026-06-09 placement-set redesign) ── */
  /* The device is room-bounded, so the count is a set of NAMED placements:
     entry pathways (doors, garage, basement) plus rooms with seen activity.
     Q_PEST drives which rooms can be offered, so the plan never names a room
     the selected pests would not use. */
  var ROOM_ORDER = ['KITCHEN', 'BATH', 'UTILITY', 'BEDROOM', 'QUIET', 'ATTIC', 'LIVING'];
  var ROOM_LABELS = {
    KITCHEN: 'Kitchen',
    BATH: 'Bathroom or under-sink',
    UTILITY: 'Utility or laundry room',
    BEDROOM: 'Bedroom',
    QUIET: 'Quiet or storage room',
    ATTIC: 'Attic',
    LIVING: 'Living or dining room'
  };
  var APT_ROOM_LABELS = {
    KITCHEN: 'Kitchen',
    BATH: 'Bathroom or under-sink',
    BEDROOM: 'Bedroom',
    QUIET: 'Closet or storage area',
    LIVING: 'Living or dining room'
  };
  var ROOM_REASONS = {
    KITCHEN: 'Place it low on the wall closest to where you see them, near the baseboard.',
    BATH: 'They follow water, so the under-sink zone gets its own device.',
    UTILITY: 'Appliance and water-heater gaps draw them, so this room is covered on its own.',
    BEDROOM: 'A room where you have seen them gets its own device, since the signal does not carry through walls.',
    QUIET: 'They settle in quiet, undisturbed corners, so a flagged quiet room gets a device.',
    ATTIC: 'Quiet, undisturbed, and connected to the wall tops, so a flagged attic gets its own device. It needs a standard outlet up there.',
    LIVING: 'A main room where you have seen them gets its own device.'
  };
  var PEST_ROOM_MAP = {
    ROACH: ['KITCHEN', 'BATH', 'UTILITY'],
    ANT: ['KITCHEN', 'BATH', 'LIVING'],
    RODENT: ['KITCHEN', 'UTILITY', 'BEDROOM', 'ATTIC'],
    SPIDER: ['QUIET', 'BEDROOM', 'LIVING', 'ATTIC']
  };
  function computeEligibleRooms(pests) {
    if (!pests || !pests.length || pests.indexOf('MIX') !== -1) return ROOM_ORDER.slice();
    var picked = [];
    pests.forEach(function(p) {
      (PEST_ROOM_MAP[p] || []).forEach(function(r) {
        if (picked.indexOf(r) === -1) picked.push(r);
      });
    });
    return ROOM_ORDER.filter(function(r) { return picked.indexOf(r) !== -1; });
  }
  function isTreatmentPath() {
    return state.path === 'ACTIVE' || state.path === 'CHRONIC';
  }
  function selectedRooms() {
    var a = state.answers;
    var arr = Array.isArray(a.Q_ROOMS) ? a.Q_ROOMS : (Array.isArray(a.Q_ROOMS_APT) ? a.Q_ROOMS_APT : []);
    return ROOM_ORDER.filter(function(r) { return arr.indexOf(r) !== -1; });
  }
  function entryOnlyRow() {
    return { zone: 'Entry-only plan', count: 0, reason: 'You do not have an active problem, so we are not adding treatment rooms. Entry coverage is the honest plan.', type: 'neutral' };
  }
  function roomTallyItems(a, labels) {
    var arr = Array.isArray(a) ? a.filter(function(id) { return id !== 'NONE'; }) : [];
    if (!arr.length) {
      return [{ zone: 'Entry-only plan', count: 0, reason: 'You have not pinpointed a room, so we are not adding treatment devices. Entry coverage is the honest plan.', type: 'neutral' }];
    }
    var items = [];
    ROOM_ORDER.forEach(function(r) {
      if (arr.indexOf(r) === -1) return;
      if (r === 'KITCHEN' && state.home === 'MOBILE') {
        items.push({ zone: 'Kitchen already covered', count: 0, reason: 'You flagged the kitchen, which your plan already covers. One device does both jobs, so we did not add another.', type: 'dedup' });
        return;
      }
      items.push({ zone: labels[r] || r, count: 1, reason: ROOM_REASONS[r], type: 'add' });
    });
    return items;
  }

  /* ── RATIONALE ENGINE ── */
  /* Each question maps to a function returning tally items:
     { zone, count, reason, type: 'add'|'neutral'|'info'|'dedup' }.
     Every +1 row corresponds to one named placement in buildPlacements(),
     so the running tally always equals the final recommendation. */
  var RATIONALES = {
    Q_PEST: function(a) {
      var labels = { RODENT: 'Mice or rats', ROACH: 'Cockroaches', SPIDER: 'Spiders', ANT: 'Ants', MIX: 'A mix of pests' };
      var arr = Array.isArray(a) ? a : [];
      var names = arr.map(function(id) { return labels[id] || id; });
      var txt = names.length ? names.join(', ') : 'Indoor pests';
      var items = [{ zone: 'Targeting: ' + txt, count: 0, reason: 'PestRx is built for indoor use. We will tailor each placement to these pests.', type: 'info' }];
      var single = (arr.length === 1 && arr[0] !== 'MIX') ? arr[0] : null;
      var rightSized = {
        ANT: { zone: 'Right-sized to ants', reason: 'Ants forage toward food and water, so we focus the kitchen and entry routes instead of pushing devices into every room.' },
        ROACH: { zone: 'Right-sized to roaches', reason: 'Roaches follow water and warmth, so we focus kitchen, bath, and utility zones and skip rooms they rarely cross.' },
        SPIDER: { zone: 'Right-sized to spiders', reason: 'Spiders settle in quiet corners, not kitchens, so we will not push kitchen coverage on you.' },
        RODENT: { zone: 'Right-sized to mice and rats', reason: 'Rodents hug low walls, storage, and utility spaces, so we skip the rooms they rarely cross.' }
      };
      if (single && rightSized[single]) {
        items.push({ zone: rightSized[single].zone, count: 0, reason: rightSized[single].reason, type: 'neutral' });
      } else if (arr.length > 1 || arr.indexOf('MIX') !== -1) {
        items.push({ zone: 'One plan for all of them', count: 0, reason: 'Picking more pests does not add devices. The same doors, garage, and basement cover all of them.', type: 'info' });
      }
      return items;
    },
    Q1: function(a) {
      var map = {
        A: { zone: 'Active problem', count: 0, reason: 'We will cover your entry pathways plus each room where you have actually seen them.', type: 'info' },
        B: { zone: 'Prevention mode', count: 0, reason: 'We will cover the entry pathways that let them in last time. No treatment devices needed.', type: 'info' },
        C: { zone: 'Getting ahead of it', count: 0, reason: 'Entry-pathway coverage only, which is the right first step. We will not pad the plan.', type: 'info' },
        D: { zone: 'Keeps coming back', count: 0, reason: 'Usually a placement gap at the entry pathways. We rebuild from there, plus any room you can pinpoint.', type: 'info' }
      };
      return [map[a]];
    },
    Q2: function(a) {
      if (a === 'A') {
        return [
          { zone: 'Front-entry threshold', count: 1, reason: 'Door thresholds are a primary route inside. One device covers the entry.', type: 'add' },
          { zone: 'Back or side-entry threshold', count: 1, reason: 'A second outside door is its own route in. Only have one outside door? You can remove this on your results.', type: 'add' }
        ];
      }
      if (a === 'B') {
        return [{ zone: 'Front-entry threshold', count: 1, reason: 'Door thresholds are a primary route inside. One device covers the entry.', type: 'add' }];
      }
      if (a === 'C') {
        return [{ zone: 'Apartment unit', count: 0, reason: 'Units have fewer direct entry points. We will size the plan to your unit, not the building.', type: 'info' }];
      }
      return [{ zone: 'Mobile home', count: 0, reason: 'Pier foundations create perimeter gaps. We will cover the main routes in.', type: 'info' }];
    },
    Q3: function(a) {
      var map = {
        A: [{ zone: 'No garage', count: 0, reason: 'No garage means one fewer entry zone. We removed it from your plan.', type: 'neutral' }],
        B: [
          { zone: 'Garage-door gap', count: 1, reason: 'One device facing the gap at the base of the garage door, where pests slip in.', type: 'add' },
          { zone: 'Door from garage into the home', count: 1, reason: 'One at the door into your living space, so the garage stays a buffer, not a hallway.', type: 'add' }
        ],
        C: [
          { zone: 'Garage-door gap', count: 1, reason: 'One device facing the gap at the base of the garage door, where pests slip in.', type: 'add' },
          { zone: 'Second garage-door opening', count: 1, reason: 'A separate garage door is its own opening, so it gets its own device.', type: 'add' },
          { zone: 'Door from garage into the home', count: 1, reason: 'One at the door into your living space, so the garage stays a buffer, not a hallway.', type: 'add' }
        ],
        D: [{ zone: 'Detached garage', count: 1, reason: 'Its own building, its own zone. One device inside covers the garage. No connecting door to guard.', type: 'add' }]
      };
      return map[a];
    },
    Q_BSMT: function(a) {
      var items;
      if (a === 'A') items = [{ zone: 'Basement (finished living area)', count: 1, reason: 'The floor above it does not carry the signal, so your finished basement needs its own device.', type: 'add' }];
      else if (a === 'B') items = [{ zone: 'Basement (unfinished)', count: 1, reason: 'An unfinished basement has more open seams, so it is a priority zone. One device, placed first.', type: 'add' }];
      else if (a === 'C') items = [{ zone: 'Crawlspace or dirt-floor space', count: 1, reason: 'More open gaps and soil contact mean more ways in, so this is your top-priority zone.', type: 'add' }];
      else items = [{ zone: 'No basement', count: 0, reason: 'No basement or crawlspace, so one fewer zone to cover.', type: 'neutral' }];
      if (!isTreatmentPath()) items.push(entryOnlyRow());
      return items;
    },
    Q3_APT: function(a) {
      var items = [];
      if (a === 'B' || a === 'D') {
        items.push({ zone: 'Main living space', count: 1, reason: 'Your entry and kitchen share one open space, so one device covers both.', type: 'add' });
      } else {
        items.push({ zone: 'Unit entry door', count: 1, reason: 'The gap under your unit door is the most common way in, so it gets a device.', type: 'add' });
      }
      if (a === 'C' || a === 'D') {
        items.push({ zone: 'Upper floor', count: 0, reason: 'Fewer direct entry points up here, so we keep the plan small.', type: 'info' });
        if (!isTreatmentPath()) items.push(entryOnlyRow());
      }
      return items;
    },
    Q_BSMT_APT: function(a) {
      var items;
      if (a === 'A') items = [{ zone: 'Basement below your unit', count: 1, reason: 'You can access the space below you, and the floor between does not carry the signal, so it gets its own device.', type: 'add' }];
      else if (a === 'B') items = [{ zone: 'Building basement noted', count: 0, reason: 'The building basement is not your unit to cover, so we did not add a device for it.', type: 'neutral' }];
      else items = [{ zone: 'On a slab', count: 0, reason: 'Nothing below your floor to cover, so one fewer zone.', type: 'neutral' }];
      if (!isTreatmentPath()) items.push(entryOnlyRow());
      return items;
    },
    Q3_MOB: function(a) {
      if (a === 'A') {
        return [{ zone: 'Walkway to attached shed or structure', count: 1, reason: 'Connected structures create a sheltered pathway. One device at the junction blocks the route.', type: 'add' }];
      }
      return [{ zone: 'No attached structures', count: 0, reason: 'No connected outbuildings, so one fewer pathway to cover.', type: 'neutral' }];
    },
    Q5_MOB: function(a) {
      var items = [
        { zone: 'Entry-door zone', count: 1, reason: 'The entry threshold is the main route in. One device covers it.', type: 'add' },
        { zone: 'Kitchen', count: 1, reason: 'Food and water make the kitchen the main draw. One device covers it.', type: 'add' }
      ];
      if (a === 'B') {
        items.push({ zone: 'Hallway corridor midpoint', count: 1, reason: 'Separated rooms need a midpoint device so the corridor between zones is covered.', type: 'add' });
      }
      if (!isTreatmentPath()) items.push(entryOnlyRow());
      return items;
    },
    Q_ROOMS: function(a) { return roomTallyItems(a, ROOM_LABELS); },
    Q_ROOMS_APT: function(a) { return roomTallyItems(a, APT_ROOM_LABELS); }
  };

  var state = { path: null, home: null, pests: [], eligibleRooms: [], doorAdjust: 0, answers: {}, history: [], currentQ: 'Q_PEST', multiSelected: [], tallyItems: [] };

  function getTotalSteps() {
    var treat = state.path === 'ACTIVE' || state.path === 'CHRONIC';
    if (state.home === 'APT') {
      var apt = state.answers.Q3_APT;
      /* Q_PEST, Q1, Q2, Q3_APT (+ Q_BSMT_APT if ground) (+ room pick if active/chronic) */
      if (!apt) return 5 + (treat ? 1 : 0); /* assume ground floor until answered */
      var ground = apt === 'A' || apt === 'B';
      return 4 + (ground ? 1 : 0) + (treat ? 1 : 0);
    }
    if (state.home === 'MOBILE') return treat ? 6 : 5;
    /* SFH / Townhouse (and pre-Q2 default): Q_PEST, Q1, Q2, Q3, Q_BSMT (+ room pick) */
    return treat ? 6 : 5;
  }

  /* Flow (2026-06-09 placement-set redesign):
     SFH/TH: Q_PEST > Q1 > Q2 > Q3 > Q_BSMT > [ACTIVE/CHRONIC: Q_ROOMS] > RECOMMEND
     APT:    Q_PEST > Q1 > Q2 > Q3_APT > [ground: Q_BSMT_APT] > [ACTIVE/CHRONIC: Q_ROOMS_APT] > RECOMMEND
     MOBILE: Q_PEST > Q1 > Q2 > Q3_MOB > Q5_MOB > [ACTIVE/CHRONIC: Q_ROOMS] > RECOMMEND */
  function getNextQ(qId) {
    var a = state.answers[qId];
    switch (qId) {
      case 'Q_PEST':
        if (!Array.isArray(a) || !a.length) { a = ['MIX']; state.answers.Q_PEST = a; }
        state.pests = a.slice();
        state.eligibleRooms = computeEligibleRooms(state.pests);
        return 'Q1';
      case 'Q1':
        state.path = { A: 'ACTIVE', B: 'PREV_HIST', C: 'PREV_NEW', D: 'CHRONIC' }[a];
        return 'Q2';
      case 'Q2':
        state.home = { A: 'SFH', B: 'TOWNHOUSE', C: 'APT', D: 'MOBILE' }[a];
        if (a === 'C') return 'Q3_APT';
        if (a === 'D') return 'Q3_MOB';
        return 'Q3';
      case 'Q3': return 'Q_BSMT';
      case 'Q_BSMT': return isTreatmentPath() ? 'Q_ROOMS' : 'RECOMMEND';
      case 'Q3_APT':
        if (a === 'A' || a === 'B') return 'Q_BSMT_APT';
        return isTreatmentPath() ? 'Q_ROOMS_APT' : 'RECOMMEND';
      case 'Q_BSMT_APT': return isTreatmentPath() ? 'Q_ROOMS_APT' : 'RECOMMEND';
      case 'Q3_MOB': return 'Q5_MOB';
      case 'Q5_MOB': return isTreatmentPath() ? 'Q_ROOMS' : 'RECOMMEND';
      case 'Q_ROOMS':
      case 'Q_ROOMS_APT':
        return 'RECOMMEND';
      default: return 'RECOMMEND';
    }
  }

  /* ── PLACEMENT SET (the count model) ──
     count = number of named placements = entry pathways + rooms with seen
     activity, deduped. Sound is room-bounded, so each named spot is one
     device. Overlaps collapse because a spot can only appear once, and the
     result lists the exact spots, so N devices always equals N named spots.
     Honest maxima: SFH 6 entry + 7 rooms = 13, APT 7, MOBILE 9. All inside
     the 1-15 variant ladder. */
  function buildPlacements() {
    var a = state.answers;
    var list = [];
    function add(name) { if (name && list.indexOf(name) === -1) list.push(name); }
    var rooms = isTreatmentPath() ? selectedRooms() : [];

    if (state.home === 'APT') {
      var studio = a.Q3_APT === 'B' || a.Q3_APT === 'D';
      var ground = a.Q3_APT === 'A' || a.Q3_APT === 'B';
      if (ground && a.Q_BSMT_APT === 'A') add('Basement below your unit');
      add(studio ? 'Main living space' : 'Unit entry door');
      rooms.forEach(function(r) { add(APT_ROOM_LABELS[r]); });
      return list;
    }

    if (state.home === 'MOBILE') {
      if (a.Q3_MOB === 'A') add('Walkway to attached shed or structure');
      add('Entry-door zone');
      add('Kitchen');
      if (a.Q5_MOB === 'B') add('Hallway corridor midpoint');
      rooms.forEach(function(r) { add(ROOM_LABELS[r]); }); /* a flagged kitchen collapses into the baseline spot */
      return list;
    }

    /* Single-family / townhouse */
    if (a.Q_BSMT === 'C') add('Crawlspace or dirt-floor space');
    else if (a.Q_BSMT === 'B') add('Basement (unfinished)');
    else if (a.Q_BSMT === 'A') add('Basement (finished living area)');
    if (a.Q3 === 'B' || a.Q3 === 'C') {
      add('Garage-door gap');
      if (a.Q3 === 'C') add('Second garage-door opening');
      add('Door from garage into the home');
    } else if (a.Q3 === 'D') {
      add('Detached garage');
    }
    add('Front-entry threshold');
    if (state.home === 'SFH' && state.doorAdjust !== -1) add('Back or side-entry threshold');
    if (state.home === 'TOWNHOUSE' && state.doorAdjust === 1) add('Back or patio-door threshold');
    rooms.forEach(function(r) { add(ROOM_LABELS[r]); });
    return list;
  }

  function computeDeviceCount() {
    return Math.max(1, Math.min(MAX_VARIANT_PACK, buildPlacements().length));
  }

  function getTemplateKey() {
    var a = state.answers;
    if (state.home === 'APT') return (a.Q3_APT === 'A' || a.Q3_APT === 'B') ? 'APT_GROUND' : 'APT_UPPER';
    if (state.home === 'MOBILE') return 'MOBILE';
    if (state.path === 'ACTIVE') {
      var rooms = selectedRooms();
      if (rooms.length === 0) return 'ACTIVE_UNLOCATED';
      if (rooms.length === 1) return 'ACTIVE_KITCHEN';
      return 'ACTIVE_MULTI';
    }
    if (state.path === 'PREV_HIST') return 'PREV_HIST';
    if (state.path === 'PREV_NEW') return 'PREV_NEW';
    return 'CHRONIC';
  }

  function getVariantForCount(count) {
    var map = window.VARIANT_MAP_BY_COUNT || {};
    var clamped = Math.max(1, Math.min(MAX_VARIANT_PACK, count));
    if (map[clamped]) return map[clamped];
    for (var i = clamped; i >= 1; i--) {
      if (map[i]) return map[i];
    }
    return { id: null, sku: '', price: '', label: clamped + '-Pack' };
  }

  /* ── PERSONALIZED CTA BUILDER (#16) ── */
  // Returns the quiz-completion CTA label. Matches the page-wide "Stop the Ants"
  // framing established 2026-05-07 (six other CTA surfaces use this phrase).
  // Previously built a zone-list string ("Protect My Garage + entry doors - N Devices")
  // which contradicted the CTA reframe and referenced Q6 (basement) which was
  // removed from the quiz on 2026-05-07.
  function buildPersonalizedCTA(count) {
    return 'Stop the Pests with ' + count + (count === 1 ? ' Device' : ' Devices');
  }

  /* Pest-specific indoor placement guidance, appended to the quiz result. */
  var PEST_GUIDANCE = {
    RODENT: 'Mice or rats: place devices low along baseboards and behind the fridge or stove, plus the garage, basement, or utility room. Seal any gap wider than a quarter inch.',
    ROACH: 'Cockroaches: target the kitchen and bathrooms, especially under the sink, behind appliances, and near drains where moisture collects.',
    SPIDER: 'Spiders: cover quiet, low-traffic spots. Corners, storage areas, basements, and around windows where they build webs.',
    ANT: 'Ants: place a device in the kitchen along the wall closest to where you see them, and near any interior door they cross to reach food or water.'
  };
  function buildPestGuidance(pests) {
    pests = Array.isArray(pests) ? pests : [];
    var keys = pests.filter(function(p) { return PEST_GUIDANCE[p]; });
    if (keys.length === 0) keys = ['ANT', 'ROACH', 'RODENT', 'SPIDER'];
    var lis = keys.map(function(k) { return '<li style="margin-bottom:0.3rem;">' + PEST_GUIDANCE[k] + '</li>'; }).join('');
    return '<div style="margin:0.5rem 0 0.75rem;padding:0.85rem 1rem;background:var(--gold-pale,#f7efda);border-radius:12px;">' +
      '<div style="font-weight:700;font-size:0.95rem;margin-bottom:0.45rem;">Where to place each device</div>' +
      '<ul style="margin:0;padding-left:1.1rem;font-size:0.9rem;line-height:1.5;">' + lis + '</ul></div>';
  }

  /* ── PROGRESSIVE VALUE DELIVERY (#17) ── */
  /* Milestones injected into the tally panel at key quiz moments */
  var MILESTONES = {
    // After Q3/Q3_APT/Q3_MOB - first structural data captured
    afterStructure: function() {
      var homeLabel = { SFH: 'single-family home', TOWNHOUSE: 'townhouse', APT: 'apartment', MOBILE: 'mobile home' }[state.home] || 'home';
      var riskLevel = (state.path === 'ACTIVE' || state.path === 'CHRONIC') ? 'high' : 'moderate';
      var riskColor = riskLevel === 'high' ? 'higher than average' : 'moderate';
      return {
        label: 'Early insight unlocked',
        text: 'We\'re building your plan around your home\'s specific entry points, not a generic recommendation.'
      };
    },
    // After Q_BSMT/Q_BSMT_APT/Q5_MOB on treatment paths, interior coverage building
    afterInterior: function() {
      var count = 0;
      state.tallyItems.forEach(function(it) { count += it.count; });
      if (count === 0) return null;
      var pct = Math.min(92, Math.max(71, 60 + count * 5));
      return {
        label: 'Coverage building',
        text: count + (count === 1 ? ' device' : ' devices') + ' locked in so far. A few more details to finalize your plan.'
      };
    }
  };

  // Track which milestones have been shown to avoid duplicates
  state.milestonesShown = {};

  function checkMilestones(qId) {
    var listEl = document.getElementById('quiz-tally-list');
    var itemsEl = listEl.querySelector('.quiz-tally-items');
    if (!itemsEl) return;

    // Milestone 1: after first structural question
    if ((qId === 'Q3' || qId === 'Q3_APT' || qId === 'Q3_MOB') && !state.milestonesShown.afterStructure) {
      var m = MILESTONES.afterStructure();
      if (m) {
        var div = document.createElement('div');
        div.className = 'quiz-tally-milestone';
        div.setAttribute('data-milestone', 'afterStructure');
        div.innerHTML = '<div class="quiz-tally-milestone-label">' + m.label + '</div><div class="quiz-tally-milestone-text">' + m.text + '</div>';
        itemsEl.appendChild(div);
        itemsEl.scrollTop = itemsEl.scrollHeight;
        state.milestonesShown.afterStructure = true;
      }
    }

    // Milestone 2: after interior layout question
    if ((qId === 'Q_BSMT' || qId === 'Q_BSMT_APT' || qId === 'Q5_MOB') && isTreatmentPath() && !state.milestonesShown.afterInterior) {
      var m2 = MILESTONES.afterInterior();
      if (m2) {
        var div2 = document.createElement('div');
        div2.className = 'quiz-tally-milestone';
        div2.setAttribute('data-milestone', 'afterInterior');
        div2.innerHTML = '<div class="quiz-tally-milestone-label">' + m2.label + '</div><div class="quiz-tally-milestone-text">' + m2.text + '</div>';
        itemsEl.appendChild(div2);
        itemsEl.scrollTop = itemsEl.scrollHeight;
        state.milestonesShown.afterInterior = true;
      }
    }
  }

  function removeMilestonesAfter(qId) {
    // If user goes back past a milestone trigger, remove it
    var structureTriggers = ['Q3', 'Q3_APT', 'Q3_MOB'];
    var interiorTriggers = ['Q_BSMT', 'Q_BSMT_APT', 'Q5_MOB'];
    if (structureTriggers.indexOf(qId) !== -1) {
      state.milestonesShown.afterStructure = false;
      var el = document.querySelector('[data-milestone="afterStructure"]');
      if (el) el.remove();
    }
    if (interiorTriggers.indexOf(qId) !== -1) {
      state.milestonesShown.afterInterior = false;
      var el2 = document.querySelector('[data-milestone="afterInterior"]');
      if (el2) el2.remove();
    }
  }

  /* ── TALLY RENDERING ── */
  function updateTally() {
    var totalCount = 0;
    state.tallyItems.forEach(function(item) { totalCount += item.count; });
    if (totalCount < 0) totalCount = 0;

    var countEl = document.getElementById('quiz-tally-count');
    var prevCount = parseInt(countEl.textContent, 10);
    if (isNaN(prevCount)) prevCount = 0;

    if (totalCount < prevCount) {
      // Count is going down - animate a ticking countdown + flash
      countEl.classList.remove('flash-down');
      void countEl.offsetWidth;
      countEl.classList.add('flash-down');
      var current = prevCount;
      var step = function() {
        current -= 1;
        if (current <= totalCount) {
          countEl.textContent = totalCount;
          return;
        }
        countEl.textContent = current;
        setTimeout(step, 140);
      };
      setTimeout(step, 140);
    } else {
      countEl.textContent = totalCount;
      countEl.classList.add('bump');
      setTimeout(function() { countEl.classList.remove('bump'); }, 300);
    }

    var listEl = document.getElementById('quiz-tally-list');
    if (state.tallyItems.length === 0) {
      listEl.innerHTML = '<div class="quiz-tally-empty">Answer the first question to start building your plan.</div>';
      return;
    }

    var html = '<div class="quiz-tally-items">';
    state.tallyItems.forEach(function(item) {
      var badgeClass = item.type;
      var badgeText;
      if (item.count > 0) badgeText = '+' + item.count;
      else if (item.count < 0) badgeText = '\u2212' + Math.abs(item.count);
      else badgeText = (item.type === 'info' ? '\u2139' : '\u2013');
      var itemClass = 'quiz-tally-item' + (item.type === 'dedup' ? ' dedup-row' : '');
      html += '<div class="' + itemClass + '">' +
        '<div class="quiz-tally-badge ' + badgeClass + '">' + badgeText + '</div>' +
        '<div class="quiz-tally-detail">' +
          '<div class="quiz-tally-zone">' + item.zone + '</div>' +
          '<div class="quiz-tally-reason">' + item.reason + '</div>' +
        '</div>' +
      '</div>';
    });
    html += '</div>';
    listEl.innerHTML = html;

    // scroll tally items to bottom to show latest
    var itemsEl = listEl.querySelector('.quiz-tally-items');
    if (itemsEl) itemsEl.scrollTop = itemsEl.scrollHeight;
  }

  function addTallyItems(qId) {
    var fn = RATIONALES[qId];
    if (!fn) return;
    var answer = state.answers[qId];
    var items = fn(answer);
    if (items && items.length > 0) {
      // tag items with source question so we can remove on back
      items.forEach(function(it) { it._source = qId; });
      state.tallyItems = state.tallyItems.concat(items);
      updateTally();
    }
  }

  function removeTallyItemsFrom(qId) {
    state.tallyItems = state.tallyItems.filter(function(it) { return it._source !== qId; });
    updateTally();
  }

  var INSIGHTS = {
    Q_PEST: function() { return 'PestRx is built for indoor use. We\'ll tailor your plan to the pests you\'re seeing inside.'; },
    Q3: function() { return 'The garage is a top pest harbor. An attached garage feeds the house through the connecting door. A detached one is its own zone to cover.'; },
    Q_BSMT: function() { return 'Pests travel inside wall voids and tend to surface in the basement. It is both an entry floor and where wall travelers come out, and the floor above does not carry the signal down to it.'; },
    Q_BSMT_APT: function() { return 'A space directly below your unit is part of your exposure. The floor between does not carry the signal.'; },
    Q3_APT: function() { return 'Ground-floor units have higher entry exposure. Upper floors still get pests via wall cavities and plumbing risers.'; },
    Q3_MOB: function() { return 'Pier-foundation gaps and attached sheds are the unique exposure here.'; },
    Q_ROOMS: function() { return 'The signal does not pass through walls, so each room where you\'ve seen activity needs its own device. We only count rooms you name.'; },
    Q_ROOMS_APT: function() { return 'The signal does not pass through walls, so each room where you\'ve seen activity needs its own device. We only count rooms you name.'; }
  };

  function renderQuestion(qId) {
    state.currentQ = qId;
    var q = QUESTIONS[qId];
    document.getElementById('quiz-question').textContent = (typeof q.text === 'function' ? q.text(state) : q.text);

    var insightEl = document.getElementById('quiz-insight');
    var insightFn = INSIGHTS[qId];
    var insightText = insightFn ? insightFn() : '';
    if (insightText) { insightEl.textContent = insightText; insightEl.style.display = 'block'; }
    else { insightEl.style.display = 'none'; }

    var optHtml = '';
    var nextBtn = document.getElementById('quiz-next');

    var filterFn = typeof q.filterOptions === 'function' ? q.filterOptions(state) : null;
    var offered = q.options.filter(function(opt) { return !filterFn || filterFn(opt); });
    if (q.multi) {
      /* Drop previously selected ids that are no longer offered (e.g. the pest mix changed) */
      state.multiSelected = state.multiSelected.filter(function(id) {
        return offered.some(function(o) { return o.id === id; });
      });
    }
    offered.forEach(function(opt) {
      var sel = q.multi
        ? (state.multiSelected.indexOf(opt.id) !== -1 ? ' selected' : '')
        : (state.answers[qId] === opt.id ? ' selected' : '');
      optHtml += '<button class="quiz-option' + sel + '" data-qid="' + qId + '" data-oid="' + opt.id + '" onclick="quizSelectOption(this,' + (q.multi ? 'true' : 'false') + ')">' + (opt.icon ? '<span class="quiz-option-icon" aria-hidden="true">' + opt.icon + '</span>' : '') + '<span class="quiz-option-text">' + opt.text + '</span>' + (q.multi ? '<span class="quiz-option-check" aria-hidden="true">✓</span>' : '<span class="quiz-option-chevron">›</span>') + '</button>';
    });
    document.getElementById('quiz-options').innerHTML = optHtml;

    if (q.multi) {
      nextBtn.style.display = 'inline-flex';
      nextBtn.disabled = q.allowZero ? false : (state.multiSelected.length === 0);
    } else {
      nextBtn.style.display = 'none';
      nextBtn.disabled = true;
    }

    var step = state.history.length + 1;
    var total = getTotalSteps();
    /* Denominator shown from step 1 (conservative default; adjusts once the path locks; fill can never move backwards) */
    document.getElementById('quiz-progress-label').textContent = 'Step ' + step + ' of ' + total;
    document.getElementById('quiz-progress-fill').style.width = (Math.max(0, (step - 1) / total) * 100) + '%';

    var backBtn = document.getElementById('quiz-back');
    backBtn.style.display = state.history.length > 0 ? 'inline-flex' : 'none';
  }

  window.quizSelectOption = function(btn, isMulti) {
    var qId = btn.getAttribute('data-qid');
    var oId = btn.getAttribute('data-oid');
    if (isMulti) {
      var q = QUESTIONS[qId] || {};
      var idx = state.multiSelected.indexOf(oId);
      if (idx === -1) {
        /* "None of these" is exclusive with the named rooms */
        if (oId === 'NONE') {
          state.multiSelected = [];
          document.querySelectorAll('#quiz-options .quiz-option').forEach(function(b) { b.classList.remove('selected'); });
        } else {
          var noneIdx = state.multiSelected.indexOf('NONE');
          if (noneIdx !== -1) {
            state.multiSelected.splice(noneIdx, 1);
            var noneBtn = document.querySelector('#quiz-options .quiz-option[data-oid="NONE"]');
            if (noneBtn) noneBtn.classList.remove('selected');
          }
        }
        state.multiSelected.push(oId);
        btn.classList.add('selected');
      } else {
        state.multiSelected.splice(idx, 1);
        btn.classList.remove('selected');
      }
      document.getElementById('quiz-next').disabled = q.allowZero ? false : (state.multiSelected.length === 0);
    } else {
      document.querySelectorAll('#quiz-options .quiz-option').forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      state.answers[qId] = oId;
      /* Debounced: rapid double-clicks must not schedule two advances (skips a question) */
      if (window.__advT) clearTimeout(window.__advT);
      window.__advT = setTimeout(function() { window.__advT = null; quizAdvance(); }, 280);
    }
  };

  window.quizNext = function() { quizAdvance(); };

  function quizAdvance() {
    var qId = state.currentQ;
    if (QUESTIONS[qId].multi) {
      state.answers[qId] = state.multiSelected.slice();
    }
    // Add rationale items for this answered question
    addTallyItems(qId);
    // Check for progressive value delivery milestones
    checkMilestones(qId);
    state.history.push(qId);
    var nextQ = getNextQ(qId);
    if (nextQ === 'RECOMMEND') {
      showResult();
    } else {
      state.multiSelected = Array.isArray(state.answers[nextQ]) ? state.answers[nextQ].slice() : [];
      renderQuestion(nextQ);
    }
  }

  window.quizBack = function() {
    if (window.__advT) { clearTimeout(window.__advT); window.__advT = null; }
    if (state.history.length === 0) return;
    var prev = state.history.pop();
    // Remove tally items and milestones from the question we're going back to
    removeTallyItemsFrom(prev);
    removeMilestonesAfter(prev);
    state.multiSelected = Array.isArray(state.answers[prev]) ? state.answers[prev].slice() : [];
    renderQuestion(prev);
  };

  function placementListHtml(placements, count) {
    var lis = placements.map(function(p) { return '<li>' + p + '</li>'; }).join('');
    return '<div class="quiz-placements-title">Your ' + count + ' placement' + (count === 1 ? '' : 's') + ', in priority order</div>' +
      '<ol class="quiz-placements">' + lis + '</ol>';
  }

  function doorAdjustHtml() {
    if (state.home === 'SFH') {
      return state.doorAdjust === -1
        ? '<button type="button" class="quiz-door-adjust" onclick="quizDoorAdjust(-1)">Have a second outside door after all? Add it back</button>'
        : '<button type="button" class="quiz-door-adjust" onclick="quizDoorAdjust(-1)">Only have one outside door? Remove the second door device</button>';
    }
    if (state.home === 'TOWNHOUSE') {
      return state.doorAdjust === 1
        ? '<button type="button" class="quiz-door-adjust" onclick="quizDoorAdjust(1)">No back or patio door? Remove it</button>'
        : '<button type="button" class="quiz-door-adjust" onclick="quizDoorAdjust(1)">Have a back or patio door too? Add a device for it</button>';
    }
    return '';
  }

  window.quizDoorAdjust = function(delta) {
    state.doorAdjust = (state.doorAdjust === delta) ? 0 : delta;
    /* Keep the running tally in sync with the placement set */
    state.tallyItems = state.tallyItems.filter(function(it) { return it._source !== 'DOOR_ADJ'; });
    if (state.doorAdjust === -1) {
      state.tallyItems.push({ zone: 'Second door removed', count: -1, reason: 'You told us you have one outside door, so we took the second door device off your plan.', type: 'dedup', _source: 'DOOR_ADJ' });
    } else if (state.doorAdjust === 1) {
      state.tallyItems.push({ zone: 'Back or patio-door threshold', count: 1, reason: 'A second outside door is its own route in, so it gets a device.', type: 'add', _source: 'DOOR_ADJ' });
    }
    updateTally();
    if (typeof gtag === 'function') {
      try { gtag('event', 'quiz_door_adjust', { quiz_id: 'pestrx_coverage', direction: state.doorAdjust }); } catch (e) {}
    }
    showResult();
  };

  function showResult() {
    var placements = buildPlacements();
    var count = Math.max(1, Math.min(MAX_VARIANT_PACK, placements.length));
    var tmpl = TEMPLATES[getTemplateKey()];
    var variantInfo = getVariantForCount(count);
    var quizVariantId = variantInfo.id || null;
    var body = tmpl.body.replace(/\[N\]/g, count);
    var pestTips = buildPestGuidance(state.pests);

    var sharedWall = state.home === 'TOWNHOUSE'
      ? '<div class="quiz-flag"><strong>Shared wall note:</strong> Devices protect your unit. Shared wall cavities are an exclusion problem, not a device problem. Seal shared wall penetrations (pipe entries, utility chases) for complete coverage.</div>' : '';

    var html = '<div class="quiz-result-inner">' +
      '<div class="quiz-result-count-row">' +
        '<div class="quiz-device-count">' + count + '</div>' +
        '<div class="quiz-device-label">' + (count === 1 ? 'device' : 'devices') + ' recommended<span class="quiz-sku-label">' + variantInfo.label + '</span></div>' +
      '</div>' +
      '<h3 class="quiz-result-headline">' + tmpl.headline + '</h3>' +
      '<p class="quiz-result-body">' + body + '</p>' +
      placementListHtml(placements, count) +
      doorAdjustHtml() +
      pestTips +
      (tmpl.flag ? '<div class="quiz-flag">' + tmpl.flag + '</div>' : '') +
      sharedWall +
      '<div class="quiz-note">Keep every device plugged in. It works as long as it is powered.</div>' +
      '<div class="quiz-social-proof" style="text-align:center;font-size:0.9rem;color:var(--ink-60);margin:0.15rem 0 0.6rem;">Joining 11,247 households already covered. 4.8/5 from 2,847 verified buyers.</div>' +
      '<button type="button" class="quiz-cta-btn" onclick="addToCartAndGo(' + quizVariantId + ')">' + buildPersonalizedCTA(count) + '</button>' +
      '<div class="free-ship-line" style="margin-top:0.35rem;margin-bottom:0.6rem;">Free shipping on orders over $55</div>' +
      '<button class="quiz-retake-btn" onclick="quizRetake()">Start over</button>' +
    '</div>';

    document.getElementById('quiz-progress-fill').style.width = '100%';
    document.getElementById('quiz-card').style.display = 'none';
    var resultEl = document.getElementById('quiz-result');
    resultEl.innerHTML = html;
    resultEl.style.display = 'block';
  }

  window.quizRetake = function() {
    if (window.__advT) { clearTimeout(window.__advT); window.__advT = null; }
    state = { path: null, home: null, pests: [], eligibleRooms: [], doorAdjust: 0, answers: {}, history: [], currentQ: 'Q_PEST', multiSelected: [], tallyItems: [], milestonesShown: {} };
    document.getElementById('quiz-result').style.display = 'none';
    document.getElementById('quiz-result').innerHTML = '';
    document.getElementById('quiz-card').style.display = 'block';
    updateTally();
    renderQuestion('Q_PEST');
  };

  renderQuestion('Q_PEST');
})();

/* ─── extracted block boundary ─── */

// Seasonal band - dynamic copy by month
(function() {
  var m = new Date().getMonth(); // 0=Jan … 11=Dec
  var heading = document.getElementById('seasonal-heading');
  var text = document.getElementById('seasonal-text');
  if (!heading || !text) return;
  var seasons = {
    // Sep–Nov: fall - rodents move indoors
    fall: {
      heading: 'Fall is when rodents move in.',
      text: 'As nights turn cold, mice and rats head indoors for warmth, water, and food, while spiders settle into quiet corners. Plug PestRx in before the first frost so your home is the harder place to move into.'
    },
    // Dec–Feb: winter - everything overwinters indoors
    winter: {
      heading: 'Pests don\'t take winter off.',
      text: 'Mice nest in walls, roaches stay close to warmth and water, and spiders tuck into basements and closets. <strong>One PestRx per room keeps your home covered</strong> through the cold months, with no traps to check.'
    },
    // Mar–May: spring - insects wake up
    spring: {
      heading: 'Spring wakes everything up.',
      text: 'Ants march in, spiders spread out, and roaches breed faster in the warmth. Plug PestRx in before the spring wave so your home reads as occupied <strong>before any of them settle in</strong>.'
    },
    // Jun–Aug: summer - peak activity across pests
    summer: {
      heading: 'Peak season for every pest.',
      text: 'Summer is when pests are most active and breeding fastest, all at once. One PestRx, plugged in, keeps rodents, roaches, spiders, and ants looking for an easier home than yours.'
    }
  };
  var s;
  if (m >= 8 && m <= 10) s = seasons.fall;       // Sep–Nov
  else if (m === 11 || m <= 1) s = seasons.winter; // Dec–Feb
  else if (m >= 2 && m <= 4) s = seasons.spring;   // Mar–May
  else s = seasons.summer;                          // Jun–Aug
  heading.textContent = s.heading;
  text.innerHTML = s.text;
})();

/* ─── extracted block boundary ─── */

/* ================================================================
   Quiz GA4 tracking
   Fires quiz funnel events to GA4 via gtag. No local storage, no
   dashboard, no beacon — GA4 is the single source of truth.
   ================================================================ */
(function() {
  /* ── GA4 dispatch ── quiz_id is attached to every event so
     multiple quizzes can share one GA4 property. */
  var QUIZ_ID = 'pestrx_coverage';
  function ga4(eventName, params) {
    if (typeof gtag !== 'function') return;
    try {
      var payload = params || {};
      payload.quiz_id = QUIZ_ID;
      gtag('event', eventName, payload);
    } catch(e) {}
  }

  /* ── mid-flow state (needed for abandon + completion context) ── */
  var quizState = {
    started: false,
    currentQ: null,
    questionStartedAt: null,
    startedAt: null,
    answers: {},
    path: null,
    home: null,
    completed: false,
    abandonFired: false  /* dedupe iOS Safari double-fires of pagehide + visibilitychange:hidden */
  };

  function emitQuestionView(qId, step) {
    quizState.currentQ = qId;
    quizState.questionStartedAt = Date.now();
    ga4('quiz_question_view', { question_id: qId, step_label: step });
  }

  function emitAnswer(qId, answer, multi) {
    var ms = quizState.questionStartedAt ? (Date.now() - quizState.questionStartedAt) : null;
    quizState.answers[qId] = answer;
    if (qId === 'Q1') quizState.path = answer;
    if (qId === 'Q2') quizState.home = answer;

    var answerStr = Array.isArray(answer) ? answer.join(',') : answer;
    ga4('quiz_answer', { question_id: qId, answer: answerStr, time_on_question_ms: ms });
  }

  // MutationObserver on the question element → detect question changes = question_view
  function installQuestionObserver() {
    var qEl = document.getElementById('quiz-question');
    var stepLabelEl = document.getElementById('quiz-progress-label');
    if (!qEl) return;
    var lastText = '';
    var mo = new MutationObserver(function() {
      var text = qEl.textContent || '';
      if (text && text !== lastText) {
        lastText = text;
        var step = stepLabelEl ? stepLabelEl.textContent : '';
        /* First-text-change = quiz start. Emit Q1 view inline to fix the
           undercount: option buttons + their data-qid are often not yet
           rendered when the observer first fires, so the qId-based
           emission below was missing the initial Q1 view for ~26 of 30
           starters. The early return prevents double-firing. */
        if (!quizState.started) {
          quizState.started = true;
          quizState.startedAt = Date.now();
          ga4('quiz_start', {});
          emitQuestionView('Q_PEST', step);
          return;
        }
        // find the actively rendered qId by reading data-qid on options or state dropdown
        var optionBtn = document.querySelector('#quiz-options .quiz-option');
        var qId = optionBtn ? optionBtn.getAttribute('data-qid') : null;
        if (qId) emitQuestionView(qId, step);
      }
    });
    mo.observe(qEl, { childList: true, characterData: true, subtree: true });
  }

  // Observe the #quiz-result becoming visible → quiz_complete
  function installResultObserver() {
    var resultEl = document.getElementById('quiz-result');
    if (!resultEl) return;
    var mo = new MutationObserver(function() {
      if (resultEl.style.display !== 'none' && resultEl.offsetHeight > 0 && !quizState.completed) {
        quizState.completed = true;
        var countEl = resultEl.querySelector('.quiz-device-count');
        var skuEl = resultEl.querySelector('.quiz-sku-label');
        var deviceCount = countEl ? parseInt(countEl.textContent, 10) : null;
        var skuLabel = skuEl ? skuEl.textContent.trim() : null;
        var totalMs = quizState.startedAt ? (Date.now() - quizState.startedAt) : null;
        ga4('quiz_complete', {
          device_count: deviceCount,
          sku: skuLabel,
          quiz_path: quizState.path,
          home_type: quizState.home,
          completion_time_ms: totalMs,
          value: deviceCount
        });
      }
    });
    mo.observe(resultEl, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  }

  // Patch quizSelectOption + quizNext + quizBack + quizRetake
  function installFunctionHooks() {
    var origSelect = window.quizSelectOption;
    if (typeof origSelect === 'function') {
      window.quizSelectOption = function(btn, isMulti) {
        var qId = btn.getAttribute('data-qid');
        var oId = btn.getAttribute('data-oid');
        // For single-select, fire immediately; for multi, wait for Next click
        if (!isMulti && qId && oId) {
          emitAnswer(qId, oId, false);
        }
        return origSelect.apply(this, arguments);
      };
    }

    var origNext = window.quizNext;
    if (typeof origNext === 'function') {
      window.quizNext = function() {
        // For multi-select, grab the selected options from the current question
        var qId = quizState.currentQ;
        if (qId) {
          var selected = Array.prototype.slice.call(document.querySelectorAll('#quiz-options .quiz-option.selected'))
            .map(function(b) { return b.getAttribute('data-oid'); });
          if (selected.length > 0) {
            emitAnswer(qId, selected, true);
          }
        }
        return origNext.apply(this, arguments);
      };
    }

    var origBack = window.quizBack;
    if (typeof origBack === 'function') {
      window.quizBack = function() {
        ga4('quiz_back', { from_question: quizState.currentQ });
        return origBack.apply(this, arguments);
      };
    }

    var origRetake = window.quizRetake;
    if (typeof origRetake === 'function') {
      window.quizRetake = function() {
        ga4('quiz_retake', {});
        quizState = { started: false, currentQ: null, questionStartedAt: null, startedAt: null, answers: {}, path: null, home: null, completed: false, abandonFired: false };
        return origRetake.apply(this, arguments);
      };
    }
  }

  // On unload, if a quiz is mid-flow, emit abandon (best-effort via sendBeacon).
  // iOS Safari fires both pagehide and visibilitychange:hidden on tab-switch (often
  // before actual exit), so we dedupe via quizState.abandonFired. Treat the resulting
  // event as a "left mid-flow at least once" signal, not a unique-user count.
  function installAbandonHook() {
    function abandonIfMidFlow() {
      if (quizState.started && !quizState.completed && !quizState.abandonFired && quizState.currentQ) {
        quizState.abandonFired = true;
        var abandonMs = quizState.startedAt ? (Date.now() - quizState.startedAt) : null;
        ga4('quiz_abandon', {
          last_question: quizState.currentQ,
          questions_answered: Object.keys(quizState.answers).length,
          abandon_time_ms: abandonMs
        });
      }
    }
    window.addEventListener('pagehide', abandonIfMidFlow);
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') abandonIfMidFlow();
    });
  }


  /* ── boot ── */
  function boot() {
    installQuestionObserver();
    installResultObserver();
    installFunctionHooks();
    installAbandonHook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();